import { useEffect, useState } from 'react'

import { socio, useRefrescarSocio } from '../api/consultas'
import { ErrorDeLaApi } from '../api/nucleo'
import { anotarIntento, borrarCookie, cookieGuardada, yaIntentado } from './cookie'

/**
 * Cuando quien entra es el dueño de un espacio (`esDueno`: su acceso de propietario, o el
 * equipo) y lleva la cookie de un socio, se le enseña al núcleo **una vez por (espacio,
 * código)**: es el núcleo quien decide si la cuenta es nueva y queda del socio. Responda lo
 * que responda, la cookie se borra —reintentar no cambiaría nada—, salvo que el fallo sea
 * de sesión.
 *
 * Devuelve si la cuenta acaba de quedar vinculada, para enseñarlo en llano.
 */
export const useAtribucion = (espacio: number, esDueno: boolean): boolean => {
  const [vinculada, setVinculada] = useState(false)
  const refrescar = useRefrescarSocio(espacio)

  useEffect(() => {
    if (!Number.isInteger(espacio) || !esDueno) return
    const codigo = cookieGuardada()
    if (!codigo || yaIntentado(espacio, codigo)) return
    anotarIntento(espacio, codigo)

    let vigente = true
    socio(espacio)
      .atribuir(codigo)
      .then((respuesta) => {
        borrarCookie()
        if (!vigente || !respuesta.ok) return
        setVinculada(true)
        refrescar()
      })
      .catch((fallo: unknown) => {
        // Sin sesión, la cookie se queda: valdrá cuando la haya.
        if (fallo instanceof ErrorDeLaApi && fallo.status === 401) return
        borrarCookie()
      })
    return () => {
      vigente = false
    }
    // Solo el espacio y si es el dueño deciden si se intenta: `refrescar` cambia de identidad
    // en cada render y ponerlo aquí repetiría el efecto sin motivo (el intento anotado lo
    // pararía, pero no hace falta llegar ahí).
  }, [espacio, esDueno])

  return vinculada
}
